import { QueryOperation, SearchQuery } from "../../code/search-query/search-query";
import { DataColumn } from "../../controls/Data.default";
import { buildSearchQuery, comboboxValue, dateRangeValue, QueryFieldMapping } from "../../code/search-query/query-mapper";
import { Dayjs } from "dayjs";
import { Tag } from "antd";
import { InputObject } from "../../controls/default";
import { BundleAssignment } from "../../repository/data.default";

export interface BundlesAssignmentsForm {
  readonly uid: string;
  readonly company: InputObject;
  readonly bundle: InputObject;
  readonly createdByUserUserName: string;
  readonly createdOn: Dayjs[];
  readonly updatedByUserUserName: string;
  readonly updatedOn: Dayjs[];
}

export const BundlesAssignmentsColumns: DataColumn[] = [
  {
    title: "Company",
    key: "companyName",
    width: 192,
    sort: true,
    defaultSort: "asc",
  },
  {
    title: "Bundle",
    key: "bundleName",
    width: 192,
    sort: true,
  },
  {
    title: "Allocated",
    key: "allocatedSubmissions",
    width: 110,
    sort: true,
  },
  {
    title: "Consumed",
    key: "consumedSubmissions",
    width: 150,
    // Sortable: predicate Count() projection (the query builder's count-sort supports filtered
    // counts). Not server-side filterable (count projections can't translate to WHERE).
    sort: true,
    transform: (value: number, record?: BundleAssignment) => {
      const allocated = record?.allocatedSubmissions;
      if (allocated != null && value > allocated) {
        return <Tag color="red">{`${value} · over ${value - allocated}`}</Tag>;
      }
      return <span>{value}</span>;
    },
  },
  {
    title: "Created by",
    key: "createdByUserUserName",
    width: 192,
    sort: true,
  },
  {
    title: "Created on",
    key: "createdOn",
    width: 192,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
  {
    title: "Updated by",
    key: "updatedByUserUserName",
    width: 192,
    sort: true,
  },
  {
    title: "Updated on",
    key: "updatedOn",
    width: 192,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
];

const bundlesAssignmentsQueryMappings: QueryFieldMapping[] = [
  { formField: "company", queryField: "companyUid", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "bundle", queryField: "bundleUid", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "createdByUserUserName", operation: QueryOperation.Contains },
  { formField: "createdOn", operation: QueryOperation.Between, transform: dateRangeValue },
  { formField: "updatedByUserUserName", operation: QueryOperation.Contains },
  { formField: "updatedOn", operation: QueryOperation.Between, transform: dateRangeValue },
];

export const mapBundlesAssignmentsViewQuery = (values: BundlesAssignmentsForm): SearchQuery =>
  buildSearchQuery(values, bundlesAssignmentsQueryMappings);
